// import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'; 
import LightModeIcon from '@mui/icons-material/LightMode';
import ButtonIcon from "./ButtonIcon";
import { useDarkMode } from "../../context/DarkModeContext";
// import { useTheme } from '@emotion/react';
import { ReactComponent as Moon } from './../../assets/icons/moon-clear-line24px.svg';
import { styled } from '@mui/material/styles'


function DarkModeToggle({ fill }) {
  const makeStyledIcon = (IconComponent) =>
    styled(IconComponent, {
      shouldForwardProp: (prop) => prop !== 'active',
    })(({ theme }) => ({
      '& svg': {
        width: 22,
        height: 22
      },
      '& path': {
        fill: fill || theme.palette.primary.main,
        width: 22,
        height: 22
      },
    }))
  const MoonIcon = makeStyledIcon(Moon)
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  // const theme = useTheme()

  return (
    <>
      <ButtonIcon role='button' onClick={toggleDarkMode}>
        {isDarkMode ? <LightModeIcon sx={{ fill: '#fff' }} /> : <MoonIcon />}
      </ButtonIcon>
    </>
  );
}

export default DarkModeToggle;
